import OptionChooser from '../components/OptionChooser';

const OPTIONS = [
  {
    key: 'yard',
    path: '/jobs/new',
    icon: 'ti-file-description',
    title: 'Yard Entry',
    subtitle: 'Log a job for a dealership — stock #, VIN, services, PO.',
  },
  {
    key: 'walkin',
    path: '/walkins/new',
    icon: 'ti-car',
    title: 'Walk-in',
    subtitle: 'Quick entry for a walk-in customer wash or detail.',
  },
];

export default function NewEntryChoice() {
  return (
    <OptionChooser
      title="New Entry"
      prompt="What kind of entry are you creating?"
      options={OPTIONS}
    />
  );
}
